<template>
  <div class="image-with-grey-bar">
    <div class="image">
      <img
        :src="content.image.sizes.large"
        :alt="content.image.name"
        v-if="content.image"
        :data-pin-url="url"
        :data-pin-media="content.image.url"
        :data-pin-description="content.image.description"
        v-on:click="imageClick(content.image.sizes.large, content.image.caption)"
      />
      <div
        class="post-image-caption"
        v-if="content.image && content.image.caption"
        v-html="content.image.caption"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "image_with_grey_bar",
  props: {
    content: Object,
    imageClick: Function,
    url: String
  }
};
</script>

<style lang="scss">
.image-with-grey-bar {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 10%;
    width: 25%;
    height: 100%;
    background: rgba(184, 184, 184, 0.2);
  }
  .image {
    position: relative;
    margin-left: 35%;
    z-index: 1;
    img {
      display: block;
      cursor: pointer;
    }
  }
}
@media (max-width: $tablet) {
  .image-with-grey-bar {
    &:before {
      display: none;
    }
    .image {
      margin-left: 0;
    }
  }
}
</style>